'use strict';

module Patersons {

    export class AccountDateRangeFilterComponent implements ng.IComponentOptions {
        templateUrl: string = 'assets/templates/portfolioSummary/components/accountDateRangeFilter.component.html';
        controller: any = AccountDateRangeFilterController;
        bindings: any = {
            defaultFromDate: '<',
            defaultToDate: '<',
            accounts: '=',
            isBusy: '<',
            onApplyFilter: '&'
        };
    }

    export class AccountDateRangeFilterController {
        accounts: Array<Account>;
        selectedAccount: Account;
        accountId: string;
        fromDate: Date;
        toDate: Date;
        defaultFromDate: Date;
        defaultToDate: Date;

        onApplyFilter: any;

        constructor() {
            if (this.defaultFromDate) {
                this.setFromDate(this.defaultFromDate);
            }
            else {
                this.setFromDate(new Date());
            }

            if (this.defaultToDate) {
                this.setToDate(this.defaultToDate);
            }
            else {
                this.setToDate(new Date());
            }

            
        }

        setSelectedAccount(accountId: string) {
            this.selectedAccount = this.accounts.filter(a => a.accountId == accountId)[0];
            console.info('selected account id: ' + this.selectedAccount.accountId);
            if(this.selectedAccount && this.fromDate && this.toDate){
                this.onApplyFilter({accountId: this.selectedAccount.accountId, fromDate: this.fromDate, toDate: this.toDate})
            }
        }

        setFromDate(fromDate: Date) {
            this.fromDate = fromDate;
            console.info('from date: ' + this.fromDate);
            if(this.selectedAccount && this.fromDate && this.toDate){
                this.onApplyFilter({accountId: this.selectedAccount.accountId, fromDate: this.fromDate, toDate: this.toDate})
            }
        }

        setToDate(toDate: Date) {
            this.toDate = toDate;
            console.info('to date: ' + this.toDate);
            if(this.selectedAccount && this.fromDate && this.toDate){
                this.onApplyFilter({accountId: this.selectedAccount.accountId, fromDate: this.fromDate, toDate: this.toDate})
            }
        }

        public $onChanges(changesObj) {
            console.log("Account Date Range Obj: ");
            console.log(changesObj);
            if(this.accounts && this.accounts[0] && !this.selectedAccount){
                this.setSelectedAccount(this.accounts[0].accountId)
            }
        }
    }
}